module.exports = __webpack_public_path__ + "img/sort.f6a2f780.svg";